import React from 'react';
import PropTypes from 'prop-types';

const formatCount = (n) => new Intl.NumberFormat('en-US').format(n);

// "By distance from venue" panel: tickets bucketed by how far each buyer's city
// is from the venue. Bars are scaled to the largest bucket so the leading band
// reads as full. Renders nothing without distance data (ungeocoded venue).
const BuyerLocationDistance = ({ breakdown, insight }) => {
  if (!breakdown || breakdown.length === 0) return null;

  const maxPct = breakdown.reduce((m, b) => Math.max(m, b.pct), 0) || 1;

  return (
    <div className="mi-buyer-loc-distance">
      <div className="mi-buyer-loc-distance-head">By distance from venue</div>

      {breakdown.map((b) => (
        <div key={b.label} className="mi-buyer-loc-dist-row">
          <span className="mi-buyer-loc-dist-label">{b.label}</span>
          <span className="mi-buyer-loc-dist-pct">{b.pct}%</span>
          <span className="mi-buyer-loc-dist-bar-track">
            <span
              className="mi-buyer-loc-dist-bar"
              style={{ width: `${Math.round((b.pct / maxPct) * 100)}%` }}
            />
          </span>
          <span className="mi-buyer-loc-dist-count">{formatCount(b.tickets)}</span>
        </div>
      ))}

      {insight && <p className="mi-buyer-loc-dist-insight">{insight}</p>}
    </div>
  );
};

BuyerLocationDistance.propTypes = {
  breakdown: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      tickets: PropTypes.number,
      pct: PropTypes.number,
    }),
  ),
  insight: PropTypes.string,
};

BuyerLocationDistance.defaultProps = { breakdown: [], insight: null };

export default BuyerLocationDistance;
